module.exports = __webpack_public_path__ + "img/5.3c45ca2b.jpg";